import moment from "moment";
import * as QueryString from "querystring";
import { InitPage } from "../index";
import axios from "axios";
import swal from "sweetalert";
import { String } from "lodash";
import { shallowEqual } from "react-redux";

declare let App: any;
declare let transferslipReceiving: any;
declare let tenantCode: string;
declare let isClientReceiving: any;
declare let startReaderUrl: any;
declare let receivingTempAssetsUrl: any;
declare let assetsReceivingTempAssetsUrl: any;
declare let deleteTempItemUrl: any;
declare let deleteTempAssetUrl: any;
declare let deleteAll: any;
declare let stopReaderUrl: any;
declare let createReceivingUrl: any;
declare let transferInUrl: any;
declare let commitEnabled: any;
declare let transferslipId: any;
declare let selectedReaderId: any;
declare let mandatoryFields: any;
declare let enablePrint: boolean;

class TransferslipReceiving {
  private actionCableConnection: any;
  private assetsCount: number = 0;
  private oldLocationCode: any = null;
  private antennas: any = [];
  init() {
    var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
    var isClientReceiving = (typeof isClientReceiving === "undefined") ? false : isClientReceiving;
    this.oldLocationCode = $('#source_location').find(':selected').val();
    const _self = this;

    $('#add_tag_btn').on('click', function() {
      $('#tag_number').val('');
      $('#invalid_tags_container').addClass('hide');
      $('#invalid_tags').html('');
      $('#manualTagAddition').modal('show');
    });

    this.initReceivingData({ reader_id: $('#reader').val(), from: this.oldLocationCode }, true);

    $('.view-icon').on('click', function() {
      $('#details').modal('show');
    });

    $('#select-reader').on('click', function() {
      $('#reader-selection').slideToggle();
    });

    $('#select-printer').on('click', function() {
      $('#printer-selection').slideToggle();
    });

    $('#printCommitBtn').on('click', function(e) {
      e.preventDefault();

      _self.commitTransfer();
    });

    $('#commitBtn').on('click', function(e) {
      e.preventDefault();

      if (!_self.checkMandatoryFields()) return;

      if (enablePrint) {
       $('#print-actions-modal').modal('show');
      } else {
        _self.commitTransfer();
      }
    });

    $("#actionBtn").on('click', function(e) {
      e.preventDefault();

      if ($(this).text() == "Start RFID") {
        _self.startReader($('#reader').val());
        _self.subscribeChannel(x, selectedReaderId);
      } else {
        _self.toggleStopReader(this);
      }
    });

    $('#reader').on('change', function() {
      if ($(this).val() == '') {
        $('#actionBtn').prop('disabled', true);
      } else {
        $('#actionBtn').removeProp('disabled');
      }
      _self.setSubzone();
      _self.setSelectedReaderId();

      _self.setAntennas();
    });

    this.setSubzone();
    this.setAntennas();
    this.setSelectedReaderId();

    $('#source_location').on('change', function() {
      _self.oldLocationCode = $('#source_location').val();
      _self.initReceivingData({ reader_id: $('#reader').val(), from: _self.oldLocationCode }, true);
      if ($(this).val() == 'Select Location' && $('#actionBtn').text() == 'Stop RFID') {
        _self.toggleStopReader($('#actionBtn'));
      }
      //   if(_self.assetsCount == 0) {
      //     _self.oldLocationCode = $('#source_location').val();
      //     return;
      //   }

      //   var readerId = $('#reader').val();
      //   swal({
      //     title: "Are you sure?",
      //     text: `Some tags were read from ${_self.oldLocationCode == 'Select Location' ? 'a different location' : `location ${_self.oldLocationCode}`}, they will be removed when the location changes.`,
      //     icon: "warning",
      //     buttons: {
      //       cancel: {
      //         text: "No",
      //         value: false,
      //         visible: true,
      //         className: "sn-btn sn-btn-sm sn-btn-silver",
      //         closeModal: true
      //       },
      //       confirm: {
      //         text: "Yes",
      //         value: true,
      //         visible: true,
      //         className: "sn-btn sn-btn-sm sn-btn-danger",
      //         closeModal: true
      //       }
      //     },
      //     dangerMode: true
      //   }).then((isConfirmed) => {
      //     if (isConfirmed) {
      //       axios.delete(`${deleteAll}/?reader_id=${readerId}&transferslip_id=${transferslipId}&from=${_self.oldLocationCode}`, {
      //         headers: {
      //           'Content-Type': 'application/json',
      //         },
      //       }).then(function(response) {
      //         _self.renderItemsTable(response.data.items);
      //         _self.renderStatistics(response.data);
      //       }).catch(function(error) {
      //         window.toastr_notifications.error(error.response.data.error, "Error");
      //       });
      //       _self.oldLocationCode = $('#source_location').val();
      //     } else {
      //       $('#source_location').val(_self.oldLocationCode);
      //     }
      //   });
    });

    $('#deleteBtn').on('click', function(e) {
      _self.deleteTransferslip();
    });

    $('#manualTagAdditionSubmit').on('click', function(e) {
      var tags = $('#tag_number').val();
      var uniqueField = $('input[name="unique_field"]:checked').val();
      _self.refreshReceivingData({
        reader_id: $('#reader').val(),
        epcs: _self.splitInput(tags).map(epc => ({ EPC: epc })),
        unique_field: uniqueField,
        action_type: 'add',
        manual: true
      }, 'manual');

      $('#commitBtn').prop('disabled', false);
    });
  }

  setAntennas() {
    let antennas = $('#reader').find('option:selected').data('antennas');
    if (Array.isArray(antennas)) {
      this.antennas = antennas.map(String);
    } else if (typeof antennas === 'number') {
      this.antennas = [String(antennas)];
    } else {
      this.antennas = String(antennas).split(',');
    }
  }

  toggleStopReader(readerElement) {
    $(readerElement).text('Start RFID');
    $(readerElement).removeClass('sn-btn-red');
    $(readerElement).addClass('sn-btn-success');
    this.unSubscribeChannel();
    this.stopReader($('#reader').val());
    $('#reader').prop('disabled', false);
    $('#zone').prop('disabled', false);
    if (commitEnabled == true) {
      $('#commitBtn').prop('disabled', false);
      commitEnabled = false;
    }
  }

  setSubzone() {
    var selectedReader = $('#reader').find('option:selected').text();
    var selectedReaderType = $('#reader').find('option:selected').data('type');
    $('#reader_name').text(selectedReader);
    if (selectedReaderType == 11) {
      $('#zones_list').show();
    } else {
      $('#zones_list').hide();
      $('#zone').val('');
    }
  }

  setSelectedReaderId() {
    selectedReaderId = $('#reader').val();
  }

  startReader(readerId) {
    var _self = this;
    axios.post(startReaderUrl,
      {
        reader_id: readerId,
        sub_zone_id: $('#zone').val(),
        from: $('#source_location').val()
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(function(response) {
        $('#actionBtn').text('Stop RFID');
        $('#actionBtn').removeClass('sn-btn-success');
        $('#actionBtn').addClass('sn-btn-red');
        $('#reader').prop('disabled', true);
        $('#zone').prop('disabled', true);
        $('#commitBtn').prop('disabled', true);
        commitEnabled = true
        _self.initReceivingData({ reader_id: readerId, sub_zone_id: $('#zone').val() });
      }).catch(function(error) {
        swal("Error", error.response.data.error, "error");
      });
  }

  stopReader(readerId) {
    axios.post(stopReaderUrl,
      {
        reader_id: readerId
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(function(response) {
      }).catch(function(error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
      });
  }

  initReceivingData(data, force = false) {
    if (transferslipId > 0 || data['reader_id'] > 0 || force) {
      var _self = this;
      axios.get(`${receivingTempAssetsUrl}?transferslip_id=${transferslipId}&reader_id=${data['reader_id']}&from=${this.oldLocationCode}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(function(response) {
        _self.renderItemsTable(response.data.items);
        _self.renderStatistics(response.data);
      }).catch(function(error) {
        window.toastr_notifications.error(error.response.data.error, "Error");
      });
    }
  }

  refreshReceivingData(data, trigger = 'auto') {
    var _self = this;
    console.log(this.antennas);
    console.log(data);
    var filtered_epcs = data['epcs'].filter(item => !item['antenna_id'] || this.antennas.includes(item['antenna_id']));
    if (filtered_epcs.length == 0) {
      return;
    }

    data['epcs'] = filtered_epcs;
    if (!data.hasOwnProperty('action_type')) {
      data['action_type'] = $('input[name="action_type"]:checked').val();
    }
    data['transferslip_id'] = transferslipId;
    data['sub_zone_id'] = $('#zone').val();
    data['from'] = this.oldLocationCode;
    data['reader_id'] = $('#reader').val();
    axios.post(receivingTempAssetsUrl, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      _self.renderItemsTable(response.data.items);
      _self.renderStatistics(response.data);
      if (trigger == 'manual') {
        if (response.data.invalid_epcs.length > 0) {
          $('#invalid_tags').html(response.data.invalid_epcs.join(', '));
          $('#invalid_tags_container').removeClass('hide');
        } else {
          $('#manualTagAddition').modal("hide");
          $('#invalid_tags_container').addClass('hide');
        }
      }
    }).catch(function(error) {
      window.toastr_notifications.error(error.response.data.error, "Error");
    });
  }

  renderStatistics(data) {
    $('#skusCount').html(data.skus_count);
    $('#assetsCount').html(data.assets_count);
    $('#expectedSkusCount').html(data.expected_skus_count);
    $('#expectedAssetsCount').html(data.expected_assets_count);
  }

  renderItemsTable(items) {
    var readerId = $('#reader').val();
    var from = $('#source_location').val();
    this.assetsCount = items.length;
    $('#itemsTable').html('');
    items.forEach(item => {
      $('#itemsTable').append(`
        <tr class="center-content ${item['item_number'] == '' ? 'text-primary' : ''}" id="item${item['item_number']}">
          <td>${item['item_number']}</td>
          <td>${item['alu']}</td>
          <td style="text-align: left !important">${item['name']}</td>
          <td>${item['tags_count']}</td>
          <td>${item['sent_qty']}</td>
          <td class="bold">${item['received_tags_count']}</td>
          <td class="bold">${item['received_qty']}</td>
          <td class="sn-icons">
            <a class="fa fa-list fa-2x view-icon" title="Show Logs" data-toggle="tooltip" style="font-size:30px" data-remote="true" href="javascript:void(0);" data-url="${assetsReceivingTempAssetsUrl}?item_number=${item['item_number']}&reader_id=${readerId}&transferslip_id=${transferslipId}&from=${from}"></a>
            <a class="fa fa-minus-circle fa-2x delete-icon deleteRecord ${transferslipId > 0 ? 'disabled' : ''}" ${transferslipId > 0 ? 'disabled' : 'onclick'}="transferslipReceiving.deleteItem('${item['item_number']}')" title="Delete" data - toggle="tooltip" data - delete -path="#" href="#/"> </a>
          </td>
        </tr>`);
    });
  }

  deleteItem(itemNumber) {
    var _self = this;
    var reader_id = $('#reader').val();
    swal({
      title: "Are you sure?",
      text: "This operation will delete the item!",
      icon: "warning",
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-silver",
          closeModal: true
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-danger",
          closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      if (isConfirmed) {
        axios.delete(`${deleteTempItemUrl}/${itemNumber}?reader_id=${reader_id}&transferslip_id=${transferslipId}&from=${$('#source_location').val()}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function(response) {
          _self.renderItemsTable(response.data.items);
          _self.renderStatistics(response.data);
        }).catch(function(error) {
          window.toastr_notifications.error(error.response.data.error, "Error");
        });
      }
    });
  }

  deleteTransferslip() {
    var _self = this;
    var reader_id = $('#reader').val();
    swal({
      title: "Are you sure?",
      text: "This operation will delete read tags!",
      icon: "warning",
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-silver",
          closeModal: true
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-danger",
          closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      if (isConfirmed) {
        axios.delete(`${deleteAll}/?reader_id=${reader_id}&transferslip_id=${transferslipId}&from=${$('#source_location').val()}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function(response) {
          _self.renderItemsTable(response.data.items);
          _self.renderStatistics(response.data);
        }).catch(function(error) {
          window.toastr_notifications.error(error.response.data.error, "Error");
        });
      }
    });
  }

  deleteTempAsset(id, itemNumber) {
    var _self = this;
    var reader_id = $('#reader').val();
    var sub_zone_id = $('#zone').val();
    swal({
      title: "Are you sure?",
      text: "This operation will delete the item!",
      icon: "warning",
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-silver",
          closeModal: true
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-danger",
          closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      if (isConfirmed) {
        axios.delete(`${deleteTempAssetUrl}/${id}?reader_id=${reader_id}&item_number=${itemNumber}&transferslip_id=${transferslipId}&from=${$('#source_location').val()}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function(response) {
          $('#assetsTable').html(response.data.result);
          _self.initReceivingData({ reader_id: reader_id, sub_zone_id: sub_zone_id });
        }).catch(function(error) {
          window.toastr_notifications.error(error.response.data.error, "Error");
        });
      }
    });
  }

  subscribeChannel(x, readerId) {
    var channel_name = x
    if (readerId != '' && readerId != null && readerId != undefined) {
      channel_name = `${x}_${readerId}`
    }
    this.actionCableConnection = App.cable.subscriptions.create(
      {
        channel: "ReadsChannel",
        tenant_code: x,
        roomId: channel_name
      },
      {
        connected() {
          console.log("Connected to ReadsChannel");
        },
        disconnected() {
          console.log("Disconnected to ReadsChannel");
        },

        received: (data: any) => this.refreshReceivingData(data)
      }
    );
  }

  unSubscribeChannel() {
    this.actionCableConnection.unsubscribe();
    this.actionCableConnection.consumer.disconnect();
    this.actionCableConnection = null;
  }

  splitInput(input) {
    return input.split(/[\n,]+/).map(item => item.trim()).filter(item => item !== "");
  }

  arrayToObject(array) {
    var result = {};
    array.forEach(function(item) {
      var keys = item.name.split("[");
      var currentObj = result;
      keys.forEach(function(key, index) {
        key = key.replace("]", "");
        if (index === keys.length - 1) {
          currentObj[key] = item.value;
        } else {
          currentObj[key] = currentObj[key] || {};
          currentObj = currentObj[key];
        }
      });
    });

    return result;
  }

  checkMandatoryFields() {
    const errors = [];
    const fields = {
      transfer_date: 'Shipping Date',
      source_location: 'From',
      document_number: 'DOC#',
      reference_number: 'REF#',
      reference1: 'REF#1',
      reference2: 'REF#2',
      reason: 'Reason'
    }
    mandatoryFields.forEach(field => {
      if (field === 'source_location' && $(`[name="${field}"]`).val() === 'Select Location') {
         errors.push(fields[field]);
       } else if (!$(`[name="${field}"]`).val()) {
         errors.push(fields[field]);
       }
    });
    if (errors.length === 0)
      return true;

    swal("Error", `The following field(s) are mandatory: ${errors.join(', ')} `, "error");
    return false;
  }
  
  commitTransfer() {
    if (!this.checkMandatoryFields()) return;

    var readerId = $('#reader').val();
    var transferData = this.arrayToObject($('#transferData').serializeArray());
    $('#transferData').find(':input:disabled').each(function() {
      transferData[$(this).attr('name')] = $(this).val();
    });
    transferData['printer_id'] = $('#printer').val();
    transferData['copies'] = $('#input_copies').val();
    transferData['reader_id'] = readerId;
    transferData['from'] = this.oldLocationCode;
    transferData['transferslip_id'] = transferslipId;
    axios.post(createReceivingUrl,
      transferData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(function(response) {
        window.toastr_notifications.success(response.data.message, '');
        window.location.href = transferInUrl;
      }).catch(function(error) {
        window.toastr_notifications.error(error.response.data.error.message, "Error");
      });
  }
}

export function LoadPage() {
  InitPage("transferslip_receiving", () => {
    const receiving = new TransferslipReceiving();
    receiving.init();
  });
}

(window as any).transferslipReceiving = new TransferslipReceiving();
